// extracted by mini-css-extract-plugin
export default {"container":"Description__container___buak8","textAreaContainer":"Description__textAreaContainer___rFAt5"};